import type { TFunction } from 'i18next';
import type { CreateOperationFormValues } from './create-payload';
import { isNonZeroSignedDecimal, isOptionalInvoiceId } from './create-payload';

export const validateCreateOperationForm = (
  values: CreateOperationFormValues,
  t: TFunction
): Record<string, string> => {
  const errors: Record<string, string> = {};
  const required = t('serviceAccounting.validation.required');

  if (!values.sum.trim()) {
    errors.sum = required;
  } else if (!isNonZeroSignedDecimal(values.sum)) {
    errors.sum = t('serviceAccounting.validation.invalidSum');
  }

  if (!values.walletId) {
    errors.walletId = t('serviceAccounting.validation.walletRequired');
  }

  if (!values.comment.trim()) {
    errors.comment = required;
  }

  if (values.invoiceId.trim() && !isOptionalInvoiceId(values.invoiceId)) {
    errors.invoiceId = t('serviceAccounting.validation.invalidInvoiceId');
  }

  if (values.type === 'expense' && !values.assetLabel.trim()) {
    errors.assetLabel = t('serviceAccounting.validation.assetLabelRequired');
  }

  return errors;
};
